const AT_PREFIXES = [
  ["shipment", "shipment"],
  ["purchase_order", "purchase order"],
  ["transfer_order", "transfer order"],
  ["shipment", "sh"],
  ["purchase_order", "po"],
  ["transfer_order", "to"],
];

const WORD_PREFIXES = [
  ["purchase_order", "purchase order"],
  ["shipment", "shipment"],
  ["purchase_order", "po"],
  ["shipment", "sh"],
];

function mentionFromAt(typed) {
  const lower = typed.toLowerCase();
  let type = null;
  let search = typed;
  for (const [recordType, prefix] of AT_PREFIXES) {
    if (lower === prefix) {
      type = recordType;
      search = "";
      break;
    }
    if (lower.startsWith(`${prefix} `)) {
      type = recordType;
      search = typed.slice(prefix.length).trim();
      break;
    }
    if (!prefix.includes(" ") && lower.startsWith(prefix) && lower.length > prefix.length) {
      type = recordType;
      search = typed.slice(prefix.length).trimStart();
      break;
    }
  }
  return { search, type };
}

export function activeMention(text, cursor) {
  const before = text.slice(0, cursor);
  const atMatch = /(^|\s)@([^@\n/]{0,80})$/.exec(before);
  if (atMatch) {
    return {
      start: atMatch.index + atMatch[1].length,
      end: cursor,
      ...mentionFromAt(atMatch[2].trimStart()),
    };
  }
  for (const [recordType, prefix] of WORD_PREFIXES) {
    const escaped = prefix.replace(/ /g, "\\s+");
    const spaced = new RegExp(`(^|\\s)(${escaped})\\s+([^\\s@]{1,80})$`, "i");
    const packed = prefix.includes(" ")
      ? null
      : new RegExp(`(^|\\s)(${escaped})(\\d[^\\s@]{0,79})$`, "i");
    const match = spaced.exec(before) || packed?.exec(before);
    if (!match) continue;
    return {
      start: match.index + match[1].length,
      end: cursor,
      search: match[3].trim(),
      type: recordType,
    };
  }
  return null;
}

function recordKey(record) {
  return `${record.type}-${record.id ?? record.name}`;
}

function mentionEndsAt(content, index) {
  if (index >= content.length) return true;
  const char = content[index];
  return /\s/.test(char) || /[.,!?;:)]/.test(char);
}

/**
 * Splits display text into plain segments and inline record chips for @name tokens.
 */
export function splitMentionedContent(content, records = []) {
  const text = content ?? "";
  if (!text) {
    return { segments: [], unusedRecords: [...records] };
  }
  if (!records.length) {
    return { segments: [{ type: "text", value: text }], unusedRecords: [] };
  }

  const sortedRecords = [...records].sort(
    (left, right) => (right.name?.length || 0) - (left.name?.length || 0),
  );
  const usedKeys = new Set();
  const segments = [];
  let pos = 0;

  while (pos < text.length) {
    const atIndex = text.indexOf("@", pos);
    if (atIndex === -1) {
      segments.push({ type: "text", value: text.slice(pos) });
      break;
    }
    if (atIndex > pos) {
      segments.push({ type: "text", value: text.slice(pos, atIndex) });
    }

    let matched = false;
    for (const record of sortedRecords) {
      const name = record.name ?? "";
      if (!name) continue;
      const token = `@${name}`;
      if (text.slice(atIndex, atIndex + token.length) !== token) continue;
      if (!mentionEndsAt(text, atIndex + token.length)) continue;
      segments.push({ type: "record", record });
      usedKeys.add(recordKey(record));
      pos = atIndex + token.length;
      matched = true;
      break;
    }

    if (!matched) {
      segments.push({ type: "text", value: "@" });
      pos = atIndex + 1;
    }
  }

  const unusedRecords = records.filter(record => !usedKeys.has(recordKey(record)));
  return { segments, unusedRecords };
}
